import { Text, View, StyleSheet, Font, } from "@react-pdf/renderer";
import React from "react";
import LatoRegular from "../../Assets/Fonts/Lato-Font/Lato-Regular.ttf";
import LatoBold from "../../Assets/Fonts/Lato-Font/Lato-Bold.ttf";
import Header from "../../Components/GeneratePdf/Header";
import Footer from "../../Components/GeneratePdf/Footer";

Font.register({
  family: "Lato",
  fonts: [ { src: LatoRegular, fontWeight: 400 }, { src: LatoBold, fontWeight: 700 }, ],
});

const styles = StyleSheet.create({
  pagewapper: { position: "relative", height: "100%", },
  content: { display: "flex", width: "570px", alignItems: "left", },
  contenttitle: { fontFamily: "Lato", fontWeight: 700, fontSize: "18px", lineHeight: "30px", color: "#426B88", },
  wapper: { width: "567px", fontFamily: "Lato", fontWeight: 400, fontSize: "12px", lineHeight: "18px", color: "#245775", },
  mainContent: { flexGrow: 1, marginTop: "28px", },
  footer: { marginTop: "auto", },
  table: { width: "100%", },
  tableRow: { flexDirection: "row", paddingVertical: 2, alignItems: "center", },
  tableHeader: { paddingVertical: 1, fontWeight: 400, border: "0px", backgroundColor: "#245775", fontWeight: "bold", color: "white", borderTopLeftRadius: 4, borderTopRightRadius: 4, },
  headerCell: { color: "white", fontWeight: 400, paddingVertical: "5px" },
  cellQuestion: { width: "70%", fontSize: 10, color: "#394554", fontWeight: 400, },
  cellScore: { width: "7%", textAlign: "center", fontSize: 10 },
  cell: { padding: "10px", textAlign: "left", },
  rowEven: { backgroundColor: "#F1F3F3", },
  rowOdd: { backgroundColor: "#FFF", },
  redRectangle: { width: 17, height: 17, backgroundColor: "#667F96", borderRadius: "1.34px", },
});

const truncateText = (text, limit) => {
  if (text.length <= limit) return text;
  return text.substring(0, text.lastIndexOf(" ", limit)) + "...";
};

const renderRectangle = (value) => {
  return value === 1 ? <View style={styles.redRectangle} /> : null;
};

const LeadershipStrategicInFocus360 = (apiData = {}) => {
  const respondentName = apiData?.apiData?.fullName?.split(' ')[0] || 'Respondent';
  const processedQuestions = data.map(item => ({
    ...item,
    question: item.question.replace(/\[First Name\]/g, respondentName)
  }));

  return(
  <View style={styles.pagewapper}>
    <Header />
    <View style={styles.content}>
      <Text style={styles.contenttitle}>STRATEGIC LEADERSHIP 360 IN FOCUS</Text>
      <View style={styles.wapper}>
        <Text>
        This chart isolates the items related to Strategic Leadership based on the OBSERVER ratings (SELF excluded). Focused results reflect the average of observer scores only. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.
        </Text>
      </View>
    </View>
    <View style={styles.mainContent}>
      <View style={[styles.tableRow, styles.tableHeader]}>
        <Text style={[styles.cell, styles.cellQuestion, styles.headerCell]}>
          Strategic
        </Text>
        {[1, 2, 3, 4].map((num) => (
          <Text key={num} style={[styles.cell, styles.cellScore, styles.headerCell]} > {num} </Text>
        ))}
      </View>

      {processedQuestions.map((item, index) => (
        <View key={index} style={[ styles.tableRow, index % 2 === 0 ? styles.rowEven : styles.rowOdd, ]} >
          <Text style={[styles.cell, styles.cellQuestion]}>
          {item.question.replace(/\[First Name\]/g, respondentName)}
          </Text>
          {item.scores.map((score, index) => (
            <View key={index} style={[styles.cell, styles.cellScore]}>
              {renderRectangle(score)}
            </View>
          ))}
        </View>
      ))}
    </View>

    <Footer />
  </View>
);
};

export default LeadershipStrategicInFocus360;

const data = [
  {
    quadrant: "Strategic",
    question: "When leading through conflict, [First Name] follows a specific process to work through it.",
    scores: [1, 1, 1, 1],
  },
  {
    quadrant: "Strategic",
    question: "[First Name] is at their best when creating standardized processes that help others achieve their goals more easily.",
    scores: [1, 1, 1, 1],
  },
  {
    quadrant: "Strategic",
    question: "[First Name] believes leading an organization requires a unified set of operating principles.",
    scores: [1, 1, 1, 1],
  },
  {
    quadrant: "Strategic",
    question: "[First Name]'s most important responsibility is the long-term stewardship of organizational assets.",
    scores: [1, 1, 1, 1],
  },
  {
    quadrant: "Strategic",
    question: "[First Name] believes effective strategy is primary.",
    scores: [1, 1, 1, 0],
  },
  {
    quadrant: "Strategic",
    question: "[First Name] is motivated by developing a clear strategic plan.",
    scores: [1, 1, 1, 0],
  },
  {
    quadrant: "Strategic",
    question: "[First Name] believes strategic thinking is the main contributor to success.",
    scores: [1, 1, 1, 0],
  },
  {
    quadrant: "Strategic",
    question: "[First Name] intentionally develops others by educating them on what they need to know.",
    scores: [1, 1, 0, 0],
  },
  {
    quadrant: "Strategic",
    question: "[First Name] believes success is contingent on thinking smarter.",
    scores: [1, 0, 0, 0],
  },
  {
    quadrant: "Strategic",
    question: "[First Name] finds great satisfaction in developing effective strategies for the organization.",
    scores: [1, 0, 0, 0],
  },
];
